import React from 'react';
import styled from 'styled-components';

const StyledCircleButton = styled.button`
  display: block;
  width: 80px;
  height: 80px;
  border-radius: 80px;
  text-align: center;
  box-sizing: border-box;
  color: #FFFFFF;
  background: #DB0007;
  box-shadow: 0px 5px 0px rgba(0, 0, 0, 0.25), inset 0px -5px 0px rgba(0, 0, 0, 0.25), inset 0px 5px 0px rgba(255, 255, 255, 0.25);
  border: none;
  outline: none;
  padding: 0;

  &:disabled {
    background: #D6D6D6;

    + p {
      opacity: 0.5;
    }
  }
`;

const CircleButton = ({ ...props }) => {
  const { onClick, children, disabled = false } = props;
  return (
    <StyledCircleButton onClick={onClick} disabled={disabled}>
      {children}
    </StyledCircleButton>
  );
}

export default CircleButton;